
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 60.329 60.329"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Circle Hotspot"}},[_c('g',{attrs:{"data-name":"Circle Outline"}},[_c('path',{attrs:{"data-name":"Quarter Outline","d":"M30.164 1a29.166 29.166 0 0129.165 29.167","fill":"none","stroke":"#05b8d2","stroke-linecap":"round","stroke-miterlimit":"10","stroke-width":"2","stroke-dasharray":"0 4.58"}})]),_c('path',{attrs:{"d":"M30.165 54.165a24 24 0 1124-24 24 24 0 01-24 24","fill":"#11365f"}}),_c('g',{attrs:{"fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-miterlimit":"10","stroke-width":"2.5"}},[_c('path',{attrs:{"data-name":"Line 4","d":"M30.164 41.165v-22"}}),_c('path',{attrs:{"data-name":"Line 5","d":"M41.164 30.165h-22"}})])])])
          )
        }
      }
    